export default __webpack_public_path__ + "static/media/full4.7d7b282f.jpg";